// Testimonials data - Real Google reviews (source: Google Avis)
export const testimonials = [
  {
    name: "danielle jayet",
    text: "Accueil convivial, coaching pro, du pur bonheur !",
    rating: 5,
    date: "Il y a 1 an",
    source: "Google Avis"
  },
  {
    name: "Héloïse Balmer",
    text: "Laurent est un excellent coach privé. Il comprend bien mes objectifs, j'apprends beaucoup grâce à son expérience. Laurent sait où sont mes limites et me corrige pour éviter les blessures. Ses encouragements me motivent à progresser et à aller plus loin à chaque séance. La salle est très bien équipée et le matériel est de haute qualité. En résumé, je le conseille vivement !",
    rating: 5,
    date: "Il y a 1 an",
    source: "Google Avis"
  },
  {
    name: "Didier Dago",
    text: "L'équipe est très pro et toujours à l'écoute. Les objectifs sont clairs, avec du challenge, mais le coaching prend ici tout son sens avec Laurent et Tarah. Très satisfait de ma décision de travailler avec Body-Up. Je recommande sans hésiter !",
    rating: 5,
    date: "Il y a 1 an",
    source: "Google Avis"
  },
  {
    name: "L P (PictAir)",
    text: "Au top, ils m'ont tué et j'adore ça ! Très bons conseils et suivi personnalisé. Coachs hyper pro et bienveillants.",
    rating: 5,
    date: "Il y a 1 an",
    source: "Google Avis"
  },
  {
    name: "Bettina Martens",
    text: "5 stars for this great training center with highly experienced and motivated coaches. I have been training now, twice a week, for 1½ year and I still look forward to each session. Thanks Coaches!!",
    rating: 5,
    date: "Il y a 1 an",
    source: "Google Avis"
  },
  {
    name: "Sabrina Bolay",
    text: "Personnel très professionnel et séances toujours adaptées à mes besoins et capacités — et les résultats sont là !",
    rating: 4,
    date: "Il y a 1 an",
    source: "Google Avis"
  },
  {
    name: "Florian Hennet",
    text: "Super coachs !",
    rating: 5,
    date: "Il y a 1 an",
    source: "Google Avis"
  },
  {
    name: "Massimo Bardini",
    text: "Good coaching and adaptive programs.",
    rating: 5,
    date: "Il y a 1 an",
    source: "Google Avis"
  },
  {
    name: "D4rkX",
    text: "Un coaching privé hors du commun avec un vrai accompagnement personnalisé ! Des services que vous ne trouverez pas ailleurs.",
    rating: 5,
    date: "Il y a 2 ans",
    source: "Google Avis"
  },
  {
    name: "Patrizia RVG",
    text: "J'adore ! Très bons, autant Laurent que Martial ! Aimables, disponibles et efficaces ! Excellents résultats ! Je recommande !",
    rating: 5,
    date: "Il y a 2 ans",
    source: "Google Avis"
  },
  {
    name: "Jane Pilet",
    text: "Laurent est exceptionnel à la fois humainement et professionnellement. Je viens à Body-Up depuis 5 ans maintenant et je n'ai pas l'intention de m'arrêter… La salle est très grande, très bien équipée et très propre. Je recommande sans hésitation !",
    rating: 5,
    date: "Il y a 4 ans",
    source: "Google Avis"
  },
  {
    name: "Margaux Schneiter",
    text: "Excellent lieu de formation avec des personnes super compétentes ! Les séances sont toujours adaptées à nos objectifs mais aussi à notre état de fatigue ;) Je recommande à tous, quel que soit le niveau ou les objectifs !",
    rating: 5,
    date: "Il y a 4 ans",
    source: "Google Avis"
  },
  {
    name: "Bar T",
    text: "Quelle meilleure référence que le fait que je prenne des séances de personal training à Body-Up depuis plus de 10 ans ! Les séances ont fortement complété mes performances dans d'autres sports (tennis, golf, ski) et ont amélioré ma force et mon endurance. Je recommande vivement Laurent pour son professionnalisme !",
    rating: 5,
    date: "Il y a 4 ans",
    source: "Google Avis"
  },
  {
    name: "Veronique Teolis",
    text: "Laurent est très professionnel, chaleureux et amical. Il sait motiver et accompagner avec intelligence et bonne humeur. Laurent m'entraîne depuis 2015 avec efficacité et précision. Je recommande sans hésitation !",
    rating: 5,
    date: "Il y a 4 ans",
    source: "Google Avis"
  },
  {
    name: "Zeus Power",
    text: "Le personnel est attentif, professionnel et efficace. La salle est magnifique et l'équipement toujours renouvelé. Service premium à un prix totalement raisonnable. Je recommande sans réserve !",
    rating: 5,
    date: "Il y a 4 ans",
    source: "Google Avis"
  },
  {
    name: "M Ill Leberk",
    text: "Endroit idéal pour (re)se mettre en forme. Coaching personnalisé de qualité, grande infrastructure, bonne humeur. Idéal pour les personnes allergiques à la forme physique traditionnelle. Pour le dire simplement, c'est parfait.",
    rating: 5,
    date: "Il y a 4 ans",
    source: "Google Avis"
  },
  {
    name: "Pierre Chretien",
    text: "Laurent Wälti est un entraîneur de première classe, passionné par son travail. Il a également beaucoup de connaissances techniques et physiologiques qui rendent la formation sûre et efficace. Je recommande chaleureusement Laurent.",
    rating: 5,
    date: "Il y a 4 ans",
    source: "Google Avis"
  },
  {
    name: "Mathieu Levrat Coaching",
    text: "Laurent est un merveilleux professionnel. Il saura vous mettre à l'aise et les résultats sont au rendez-vous. Je suis client depuis plus de 3 ans et j'en suis très satisfait !",
    rating: 5,
    date: "Il y a 4 ans",
    source: "Google Avis"
  },
  {
    name: "Christian RINDERKNECHT",
    text: "Excellent entraîneur sportif, très attentif et compétent. Je recommande vivement en particulier à tous ceux qui souffrent de problèmes de dos. Grâce à l'entraînement ciblé, la grande majorité des problèmes sont rapidement résolus.",
    rating: 5,
    date: "Il y a 4 ans",
    source: "Google Avis"
  },
  {
    name: "Ernesto Pedro Traulsen",
    text: "Laurent m'a considérablement aidé à améliorer mon niveau de forme physique et mes performances au tennis avec une combinaison de force, de vitesse et d'exercices de coordination. Je recommande fortement les sessions individuelles.",
    rating: 5,
    date: "Il y a 4 ans",
    source: "Google Avis"
  },
  {
    name: "Nikolaos Kornaros",
    text: "Laurent est un excellent entraîneur. Compétent, attentif et toujours à la pointe ! Je recommande fortement !",
    rating: 5,
    date: "Il y a 4 ans",
    source: "Google Avis"
  },
  {
    name: "Serge Moser",
    text: "Professionnel, amical, impliqué, parvient à diversifier les exercices d'une session à l'autre. En bref, fortement recommandé !",
    rating: 5,
    date: "Il y a 4 ans",
    source: "Google Avis"
  },
  {
    name: "Roseline Lafay Bottinelli",
    text: "Communication, professionnalisme, qualité : tout est parfait !",
    rating: 5,
    date: "Il y a 4 ans",
    source: "Google Avis"
  },
  {
    name: "Bryan Parker",
    text: "Laurent sait comment affiner l'entraînement à vos besoins et tester vos limites quand vous êtes prêt. Recommandation forte.",
    rating: 5,
    date: "Il y a 4 ans",
    source: "Google Avis"
  },
  {
    name: "Emre alçelik",
    text: "Fortement recommandé ! Une très bonne équipe qui fait très bien son travail.",
    rating: 5,
    date: "Il y a 4 ans",
    source: "Google Avis"
  },
  {
    name: "Pritam Singh",
    text: "Tout simplement le meilleur !",
    rating: 5,
    date: "Il y a 4 ans",
    source: "Google Avis"
  },
  {
    name: "Egemen Yorukoglu",
    text: "Communication, professionnalisme, qualité.",
    rating: 5,
    date: "Il y a 4 ans",
    source: "Google Avis"
  },
  {
    name: "Lydie Lamothe",
    text: "Professionnalisme et qualité au rendez-vous.",
    rating: 5,
    date: "Il y a 4 ans",
    source: "Google Avis"
  }
];
